export default (theme) => ({
  integratedInput: {
    color: '#5C57FF',
  }
});
